import { lazy, Suspense } from "react";
import { Route, Switch } from "wouter";
import ErrorBoundary from "@/components/ErrorBoundary";
import SiteLayout from "@/components/SiteLayout";
import Home from "@/pages/Home";

const loadInterior = () => import("@/pages/InteriorPages");
const Practice = lazy(() => loadInterior().then((module) => ({ default: module.Practice })));
const Research = lazy(() => loadInterior().then((module) => ({ default: module.Research })));
const FilmsArt = lazy(() => loadInterior().then((module) => ({ default: module.FilmsArt })));
const Teaching = lazy(() => loadInterior().then((module) => ({ default: module.Teaching })));
const About = lazy(() => loadInterior().then((module) => ({ default: module.About })));
const CV = lazy(() => loadInterior().then((module) => ({ default: module.CV })));
const Contact = lazy(() => loadInterior().then((module) => ({ default: module.Contact })));
const ProjectDetail = lazy(() => loadInterior().then((module) => ({ default: module.ProjectDetail })));
const NotFoundPage = lazy(() => loadInterior().then((module) => ({ default: module.NotFoundPage })));

function Router() {
  return (
    <SiteLayout>
      <Suspense fallback={<div className="route-loading" role="status">Loading…</div>}>
        <Switch>
          <Route path="/" component={Home} />
          <Route path="/practice" component={Practice} />
          <Route path="/research" component={Research} />
          <Route path="/films-art" component={FilmsArt} />
          <Route path="/teaching" component={Teaching} />
          <Route path="/about" component={About} />
          <Route path="/cv" component={CV} />
          <Route path="/contact" component={Contact} />
          <Route path="/work/:slug" component={ProjectDetail} />
          <Route component={NotFoundPage} />
        </Switch>
      </Suspense>
    </SiteLayout>
  );
}

export default function App() {
  return <ErrorBoundary><Router /></ErrorBoundary>;
}
